<dx-button style="width: 100%; height: 26px !important;" text="Clear All" (click)="btnClick.emit()"></dx-button>
